import { Referral, ReferralControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  referral: Referral;
  xTENANTID?: string;
}

export const useAddReferral = () =>
  useMutationWithLoading(async (params: Params) =>
    new ReferralControllerApi(getConfigObject()).createReferral(
      params.referral,
      params.xTENANTID
    )
  );
